@defer (when claim) {
    <div class="container mt-4">
        <div class="row justify-content-center">
            <div class="col-12 w-100">
                <div class="heading-lg text-center">{{ claim?.policyType }}</div>
                <div class="heading-md text-center mb-3">{{ claim?.coverageType }} Claim</div>
                <div class="heading-sm mb-4 text-center">To be completed by the attending physician</div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12 col-md-6">
                <div class="card">
                    <!-- Using a custom class instead of overriding padding -->
                    <div class="card-body">
                        <form [formGroup]="claimForm">
                            <div class="row mb-4">
                                <div class="col-12">
                                    <div class="caption">
                                        Claim number:&nbsp;
                                        <span class="caption-lg">{{ claim?.claimReferenceNumber }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="heading-sm mb-4">I hereby certify to A.W.G. Dewar, Inc. that:</div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-xl-6" formGroupName="physicianStudent">
                                    <div class="form-group mb-4">
                                        <label for="firstName" class="form-label">Student first name</label>
                                        <input type="text" class="form-control" id="firstName" formControlName="firstName" appShowFieldErrors="First name" maxlength="50" />
                                    </div>
                                </div>
                                <div class="col-12 col-xl-6" formGroupName="physicianStudent">
                                    <div class="form-group mb-4">
                                        <label for="lastName" class="form-label">Student last name</label>
                                        <input type="text" class="form-control" id="lastName" formControlName="lastName" appShowFieldErrors="Last name" maxlength="50" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="caption mb-2">a student at</div>
                                    <div class="heading-sm mb-3">{{ claim.accountName }}</div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group mb-4 position-relative">
                                        <label for="physicianSeparationReason" class="form-label">
                                            has been a patient under my care and has withdrawn or been absent from school due to the following medical condition
                                        </label>
                                        <textarea
                                            type="text"
                                            id="physicianSeparationReason"
                                            class="form-control"
                                            formControlName="physicianSeparationReason"
                                            appShowFieldErrors="Medical condition"
                                            maxlength="1000"
                                            (input)="updateCharacterCount($event, 'physicianSeparationReason')"></textarea>
                                        <div class="text-small form-text text-end char-count">{{ characterCounts.physicianSeparationReason }}/1000 characters</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-xl-6">
                                    <div class="form-group mb-4">
                                        <label for="physicianICDDSM" class="form-label">Diagnosis codes(s) (ICD/DSM)</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="physicianICDDSM"
                                            formControlName="physicianICDDSM"
                                            appShowFieldErrors="Diagnosis codes(s) (ICD/DSM)"
                                            maxlength="25" />
                                    </div>
                                </div>
                            </div>
                            <div class="row align-items-top">
                                <div class="col-12 col-xl-6">
                                    <div class="form-group mb-4">
                                        <label for="physicianClassAbsenceStartDate" class="form-label">The student has been unable to attend class from</label>
                                        <div class="input-group mb-3">
                                            <input
                                                class="form-control"
                                                id="physicianClassAbsenceStartDate"
                                                formControlName="physicianClassAbsenceStartDate"
                                                placeholder="mm/dd/yyyy"
                                                name="physicianClassAbsenceStartDate"
                                                ngbDatepicker
                                                appDateMask
                                                [minDate]="minValidDate"
                                                [maxDate]="maxValidDate"
                                                firstDayOfWeek="7"
                                                #physicianClassAbsenceStartDate="ngbDatepicker"
                                                appShowFieldErrors="Class absence start date"
                                                (ngModelChange)="validateDateRange('physicianClassAbsenceStartDate', 'physicianClassAbsenceEndDate')" />

                                            <button class="btn btn-input-group" type="button" (click)="physicianClassAbsenceStartDate.toggle()">
                                                <i class="bi bi-calendar3"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-xl-6">
                                    <div class="form-group mb-4">
                                        <label for="physicianClassAbsenceEndDate" class="form-label">The student has been unable to attend class to</label>
                                        <div class="input-group mb-3">
                                            <input
                                                class="form-control"
                                                id="physicianClassAbsenceEndDate"
                                                formControlName="physicianClassAbsenceEndDate"
                                                placeholder="mm/dd/yyyy"
                                                name="physicianClassAbsenceEndDate"
                                                ngbDatepicker
                                                appDateMask
                                                [minDate]="minValidDate"
                                                [maxDate]="maxValidDate"
                                                firstDayOfWeek="7"
                                                #physicianClassAbsenceEndDate="ngbDatepicker"
                                                appShowFieldErrors="Class absence end date"
                                                (ngModelChange)="validateDateRange('physicianClassAbsenceStartDate', 'physicianClassAbsenceEndDate')" />
                                            <button class="btn btn-input-group" type="button" (click)="physicianClassAbsenceEndDate.toggle()">
                                                <i class="bi bi-calendar3"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row align-items-top">
                                <div class="col-12 col-xl-6">
                                    <div class="form-group mb-4">
                                        <label for="physicianFirstConsultDate" class="form-label">Date first consulted for this condition</label>
                                        <div class="input-group mb-3">
                                            <input
                                                class="form-control"
                                                id="physicianFirstConsultDate"
                                                formControlName="physicianFirstConsultDate"
                                                placeholder="mm/dd/yyyy"
                                                name="physicianFirstConsultDate"
                                                ngbDatepicker
                                                appDateMask
                                                [minDate]="minConsultDate"
                                                [maxDate]="maxValidDate"
                                                firstDayOfWeek="7"
                                                #physicianFirstConsultDate="ngbDatepicker"
                                                appShowFieldErrors="First consulted date"
                                                (ngModelChange)="validateDateRange('physicianFirstConsultDate', 'physicianLastConsultDate')" />
                                            <button class="btn btn-input-group" type="button" (click)="physicianFirstConsultDate.toggle()">
                                                <i class="bi bi-calendar3"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-xl-6">
                                    <div class="form-group mb-4">
                                        <label for="physicianLastConsultDate" class="form-label">Date last consulted for this condition</label>
                                        <div class="input-group mb-3">
                                            <input
                                                class="form-control"
                                                id="physicianLastConsultDate"
                                                formControlName="physicianLastConsultDate"
                                                placeholder="mm/dd/yyyy"
                                                name="physicianLastConsultDate"
                                                ngbDatepicker
                                                appDateMask
                                                [minDate]="minValidDate"
                                                [maxDate]="maxValidDate"
                                                firstDayOfWeek="7"
                                                #physicianLastConsultDate="ngbDatepicker"
                                                appShowFieldErrors="Last consulted date"
                                                (ngModelChange)="validateDateRange('physicianFirstConsultDate', 'physicianLastConsultDate')" />
                                            <button class="btn btn-input-group" type="button" (click)="physicianLastConsultDate.toggle()">
                                                <i class="bi bi-calendar3"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-lg-12 mt-4 mt-lg-0">
                                <div class="row">
                                    <div class="form-label">Number of professional visits for this condition:</div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-xl-4">
                                        <div class="form-group mb-4">
                                            <label for="physicianHomeVisitCount" class="form-label"># of Home visits</label>
                                            <input
                                                type="text"
                                                id="physicianHomeVisitCount"
                                                class="form-control"
                                                formControlName="physicianHomeVisitCount"
                                                appShowFieldErrors="# of home visits"
                                                currencyFormat
                                                placeholder="0"
                                                inputmode="number"
                                                maxlength="9"
                                                maxDigits="6" />
                                        </div>
                                    </div>

                                    <div class="col-12 col-xl-4">
                                        <div class="form-group mb-4">
                                            <label for="physicianOfficeVisitCount" class="form-label"># of Office visits</label>
                                            <input
                                                type="text"
                                                id="physicianOfficeVisitCount"
                                                class="form-control currency-input"
                                                formControlName="physicianOfficeVisitCount"
                                                appShowFieldErrors="# of office visits"
                                                currencyFormat
                                                placeholder="0"
                                                inputmode="number"
                                                maxlength="9"
                                                maxDigits="6" />
                                        </div>
                                    </div>

                                    <div class="col-12 col-xl-4">
                                        <div class="form-group mb-4">
                                            <label for="physicianHospitalVisitCount" class="form-label"># of Hospital visits</label>
                                            <input
                                                type="text"
                                                id="physicianHospitalVisitCount"
                                                class="form-control currency-input"
                                                formControlName="physicianHospitalVisitCount"
                                                appShowFieldErrors="# of hospital visits"
                                                currencyFormat
                                                placeholder="0"
                                                inputmode="number"
                                                maxlength="9"
                                                maxDigits="6" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-xl-12">
                                    <div class="form-group mb-4">
                                        <label for="physicianStillUnderCare" class="form-label me-2">Is the student still under your care for the above condition?</label>
                                        <fieldset class="radio-checkboxes">
                                            <div class="radio-checkboxes-tiles">
                                                <label class="radio-checkbox">
                                                    <input
                                                        type="radio"
                                                        id="physicianStillUnderCareYes"
                                                        class="radio-checkbox-input"
                                                        formControlName="physicianStillUnderCare"
                                                        [value]="true" />
                                                    <div class="radio-checkbox-content-area">
                                                        <span class="radio-checkbox-title">Yes</span>
                                                    </div>
                                                </label>
                                                <label class="radio-checkbox">
                                                    <input
                                                        type="radio"
                                                        id="physicianStillUnderCareNo"
                                                        class="radio-checkbox-input"
                                                        formControlName="physicianStillUnderCare"
                                                        [value]="false"
                                                        appShowFieldErrors="Selection" />
                                                    <div class="radio-checkbox-content-area">
                                                        <span class="radio-checkbox-title">No</span>
                                                    </div>
                                                </label>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group mb-4 position-relative">
                                        <label for="physicianReferredPhysicianInfo" class="form-label">
                                            If you referred the student to another physician, please provide their name and address:
                                        </label>
                                        <textarea
                                            type="text"
                                            id="physicianReferredPhysicianInfo"
                                            class="form-control"
                                            formControlName="physicianReferredPhysicianInfo"
                                            appShowFieldErrors="Referred physician info"
                                            maxlength="255"
                                            (input)="updateCharacterCount($event, 'physicianReferredPhysicianInfo')"></textarea>
                                        <div class="text-small form-text text-end char-count">{{ characterCounts.physicianReferredPhysicianInfo }}/255 characters</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 mb-4">
                                    <div class="form-group mb-4 position-relative">
                                        <label for="physicianReferringPhysicianInfo" class="form-label">
                                            If the student was referred to you by another physician, please provide their name and address:
                                        </label>
                                        <textarea
                                            type="text"
                                            id="physicianReferringPhysicianInfo"
                                            class="form-control"
                                            formControlName="physicianReferringPhysicianInfo"
                                            appShowFieldErrors="Referring physician info"
                                            maxlength="255"
                                            (input)="updateCharacterCount($event, 'physicianReferringPhysicianInfo')"></textarea>
                                        <div class="text-small form-text text-end char-count">{{ characterCounts.physicianReferringPhysicianInfo }}/255 characters</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-lg-12">
                                    <div class="form-group mb-4">
                                        <label for="physicianWithdrawnOnRecommendation" class="form-label me-2">
                                            Has this student been withdrawn on your recommendation from classes for the rest of the academic year?
                                        </label>
                                        <fieldset class="radio-checkboxes">
                                            <div class="radio-checkboxes-tiles">
                                                <label class="radio-checkbox">
                                                    <input
                                                        type="radio"
                                                        id="physicianWithdrawnOnRecommendationYes"
                                                        class="radio-checkbox-input"
                                                        formControlName="physicianWithdrawnOnRecommendation"
                                                        [value]="true" />
                                                    <div class="radio-checkbox-content-area">
                                                        <span class="radio-checkbox-title">Yes</span>
                                                    </div>
                                                </label>
                                                <label class="radio-checkbox">
                                                    <input
                                                        type="radio"
                                                        id="physicianWithdrawnOnRecommendationNo"
                                                        class="radio-checkbox-input"
                                                        formControlName="physicianWithdrawnOnRecommendation"
                                                        [value]="false"
                                                        appShowFieldErrors="Selection" />
                                                    <div class="radio-checkbox-content-area">
                                                        <span class="radio-checkbox-title">No</span>
                                                    </div>
                                                </label>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group mb-4 position-relative">
                                        <label for="physicianWithdrawalRecommendationReason" class="form-label">
                                            Please provide the reason for recommending or not recommending withdrawal:
                                        </label>
                                        <textarea
                                            type="text"
                                            id="physicianWithdrawalRecommendationReason"
                                            class="form-control"
                                            formControlName="physicianWithdrawalRecommendationReason"
                                            appShowFieldErrors="Withdrawal recommendation reason"
                                            maxlength="1000"
                                            (input)="updateCharacterCount($event, 'physicianWithdrawalRecommendationReason')"></textarea>
                                        <div class="text-small form-text text-end char-count">{{ characterCounts.physicianWithdrawalRecommendationReason }}/1000 characters</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group mb-4 position-relative">
                                        <label for="physicianAnticipatedReturnDescription" class="form-label">
                                            When do you anticipate the student will be able to resume classes at the above-mentioned School?
                                        </label>
                                        <textarea
                                            type="text"
                                            id="physicianAnticipatedReturnDescription"
                                            class="form-control"
                                            formControlName="physicianAnticipatedReturnDescription"
                                            appShowFieldErrors="Medical condition"
                                            maxlength="255"
                                            (input)="updateCharacterCount($event, 'physicianAnticipatedReturnDescription')"></textarea>
                                        <div class="text-small form-text text-end char-count">{{ characterCounts.physicianAnticipatedReturnDescription }}/255 characters</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-lg-12">
                                    <div class="form-group mb-4">
                                        <label for="physicianAlternateSchoolOrEmploymentDuringLeave" class="form-label me-2">
                                            Is the student now attending or planning to enroll in another school (or become gainfully employed) during the period of withdrawal from
                                            the above-mentioned School?
                                        </label>
                                        <fieldset class="radio-checkboxes">
                                            <div class="radio-checkboxes-tiles">
                                                <label class="radio-checkbox">
                                                    <input
                                                        type="radio"
                                                        id="physicianAlternateSchoolOrEmploymentDuringLeaveYes"
                                                        class="radio-checkbox-input"
                                                        formControlName="physicianAlternateSchoolOrEmploymentDuringLeave"
                                                        [value]="true" />
                                                    <div class="radio-checkbox-content-area">
                                                        <span class="radio-checkbox-title">Yes</span>
                                                    </div>
                                                </label>
                                                <label class="radio-checkbox">
                                                    <input
                                                        type="radio"
                                                        id="physicianAlternateSchoolOrEmploymentDuringLeaveNo"
                                                        class="radio-checkbox-input"
                                                        formControlName="physicianAlternateSchoolOrEmploymentDuringLeave"
                                                        [value]="false"
                                                        appShowFieldErrors="Selection" />
                                                    <div class="radio-checkbox-content-area">
                                                        <span class="radio-checkbox-title">No</span>
                                                    </div>
                                                </label>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>

                            <div class="row align-items-top">
                                <div class="col-12 col-lg-6">
                                    <div class="form-group mb-4">
                                        <label for="physicianWithPhysicianPermission" class="form-label me-2">If “yes”, is this with your permission?</label>
                                        <fieldset class="radio-checkboxes">
                                            <div class="radio-checkboxes-tiles">
                                                <label class="radio-checkbox">
                                                    <input
                                                        type="radio"
                                                        id="physicianWithPhysicianPermissionYes"
                                                        class="radio-checkbox-input"
                                                        formControlName="physicianWithPhysicianPermission"
                                                        [value]="true" />
                                                    <div class="radio-checkbox-content-area">
                                                        <span class="radio-checkbox-title">Yes</span>
                                                    </div>
                                                </label>
                                                <label class="radio-checkbox">
                                                    <input
                                                        type="radio"
                                                        id="physicianWithPhysicianPermissionNo"
                                                        class="radio-checkbox-input"
                                                        formControlName="physicianWithPhysicianPermission"
                                                        [value]="false"
                                                        appShowFieldErrors="Selection" />
                                                    <div class="radio-checkbox-content-area">
                                                        <span class="radio-checkbox-title">No</span>
                                                    </div>
                                                </label>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>

                            <div class="row align-items-top">
                                <div class="form-group mb-2">
                                    <div class="form-group mb-4 col-12 col-lg-12">
                                        <label for="physicianAlternateActivityStartDate" class="form-label">
                                            If “yes”, please provide the approximate date and details as to why they can attend a different school or start employment
                                        </label>
                                    </div>
                                    <div class="col-12 col-lg-6">
                                        <div class="input-group mb-3">
                                            <input
                                                class="form-control"
                                                id="physicianAlternateActivityStartDate"
                                                formControlName="physicianAlternateActivityStartDate"
                                                placeholder="mm/dd/yyyy"
                                                name="physicianAlternateActivityStartDate"
                                                ngbDatepicker
                                                appDateMask
                                                [minDate]="minValidDate"
                                                [maxDate]="maxValidDate"
                                                firstDayOfWeek="7"
                                                #physicianAlternateActivityStartDate="ngbDatepicker"
                                                appShowFieldErrors="Alternate activity start date" />
                                            <button class="btn btn-input-group" type="button" (click)="physicianAlternateActivityStartDate.toggle()">
                                                <i class="bi bi-calendar3"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group mb-4 position-relative">
                                        <label for="physicianAlternateActivityExplanation" class="form-label">Details</label>
                                        <textarea
                                            type="text"
                                            id="physicianAlternateActivityExplanation"
                                            class="form-control"
                                            formControlName="physicianAlternateActivityExplanation"
                                            appShowFieldErrors="Alternate activity explanation"
                                            maxlength="255"
                                            (input)="updateCharacterCount($event, 'physicianAlternateActivityExplanation')"></textarea>
                                        <div class="text-small form-text text-end char-count">{{ characterCounts.physicianAlternateActivityExplanation }}/255 characters</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-4 mt-4">
                                <div class="col-12">
                                    <div class="section-heading">Physician Information</div>
                                </div>
                            </div>
                            <fieldset formGroupName="physician">
                                <div class="row">
                                    <div class="col-12 col-xl-6">
                                        <div class="form-group mb-4">
                                            <label for="physicianFirstName" class="form-label">First name</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="physicianFirstName"
                                                formControlName="firstName"
                                                appShowFieldErrors="First name"
                                                maxlength="50" />
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-6">
                                        <div class="form-group mb-4">
                                            <label for="physicianLastName" class="form-label">Last name</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="physicianLastName"
                                                formControlName="lastName"
                                                appShowFieldErrors="Last name"
                                                maxlength="50" />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <div class="row">
                                <div class="col-12 col-xl-6">
                                    <div class="form-group mb-4">
                                        <label for="physicianLicenseNumber" class="form-label">License #</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="physicianLicenseNumber"
                                            formControlName="physicianLicenseNumber"
                                            appShowFieldErrors="License #"
                                            maxlength="20" />
                                    </div>
                                </div>
                                <div class="col-12 col-xl-6" formGroupName="physician">
                                    <div class="form-group mb-4">
                                        <label for="phone" class="form-label">Phone</label>
                                        <input
                                            type="tel"
                                            class="form-control"
                                            id="phone"
                                            inputmode="tel"
                                            placeholder="(555) 555-5555"
                                            mask="(000) 000-0000"
                                            #phone
                                            formControlName="phoneNumber"
                                            appShowFieldErrors="Phone" />
                                    </div>
                                </div>
                            </div>
                            <fieldset formGroupName="physician">
                                <div class="row">
                                    <div class="col-12 col-xl-6">
                                        <div class="form-group mb-4">
                                            <label for="emailAddress" class="form-label">Email address</label>
                                            <input type="text" class="form-control" id="emailAddress" formControlName="emailAddress" appShowFieldErrors="Email" maxlength="255" />
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 mb-lg-0 d-flex align-items-center">
                                        <div class="form-text email-address">Email is only used for claim processing/questions.</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12" formGroupName="address">
                                        <div class="form-group mb-4">
                                            <label for="address1" class="form-label">Address</label>
                                            <input type="text" class="form-control" id="address1" formControlName="address1" appShowFieldErrors="Address" maxlength="200" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    @if (showAddress2) {
                                        <div class="col-12" formGroupName="address">
                                            <div class="form-group mb-4">
                                                <label for="address2" class="form-label">Building, apartment, floor or other</label>
                                                <input type="text" class="form-control" id="address2" formControlName="address2" maxlength="200" />
                                            </div>
                                        </div>
                                    } @else {
                                        <a class="form-text mb-3" (click)="toggleAddress2()">+ Add building, apartment, floor or other</a>
                                    }
                                </div>
                                <div class="row">
                                    <div class="col-12" formGroupName="address">
                                        <div class="form-group mb-4">
                                            <label for="city" class="form-label">City</label>
                                            <input type="text" class="form-control" id="city" formControlName="city" appShowFieldErrors="City" maxlength="100" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-md-6" formGroupName="address">
                                        <div class="form-group mb-4">
                                            <label for="state" class="form-label">{{ stateCaption }}</label>
                                            <select id="state" class="form-control form-select" formControlName="stateAbbreviation" appShowFieldErrors="{{ stateCaption }}">
                                                <option></option>
                                                @for (state of filteredStates; track $index) {
                                                    <option [value]="state.stateAbbreviation">{{ state.stateName }}</option>
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6" formGroupName="address">
                                        <div class="form-group mb-4">
                                            <label for="postalCode" class="form-label">{{ postalCodeCaption }}</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="postalCode"
                                                formControlName="postalCode"
                                                appShowFieldErrors="{{ postalCodeCaption }}"
                                                maxlength="10" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-4">
                                    <div class="col-12 col-xl-6" formGroupName="address">
                                        <label for="country" class="form-label">Country/Region</label>
                                        <div class="form-group mb-4">
                                            <select
                                                id="country"
                                                class="form-control form-select"
                                                formControlName="countryISO3"
                                                appShowFieldErrors="Country"
                                                (change)="onCountryChange($event)">
                                                <option></option>
                                                @for (country of countries; track $index) {
                                                    <option [value]="country.iso3">{{ country.countryName }}</option>
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group mb-4">
                                        <label for="physicianSignature" class="form-label">Signature</label>
                                        <app-signature-pad formControlName="physicianSignature" appShowFieldErrors="Signature"></app-signature-pad>
                                        <div class="text-small form-text mt-2">{{ signatureText }}</div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div class="row">
                            <div class="col-12 text-center">
                                <button class="btn btn-link" (click)="fraudNotice()">Important fraud information regarding your claim</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="caption mt-3" [innerHTML]="instructionText"></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-center">
                                <button
                                    class="btn btn-primary me-3 mt-5 mb-5"
                                    (click)="onSubmit()"
                                    (keydown.enter)="onSubmit()"
                                    [disabled]="isSaving"
                                    [class.btn--waiting]="isSaving">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Fraud Notices Modal Template -->
} @placeholder {
    <div class="container mt-4">
        <div class="row text-center">
            <div class="col-12 heading-md pb-2">Loading Claim...</div>
        </div>
    </div>
}
